import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit'
import {
  useDispatch, TypedUseSelectorHook, useSelector
} from 'react-redux'
import { AppDispatch, RootState } from '../redux/store'
import { State } from '../redux/store.types'

export const useAppDispatch = () =>
  useDispatch<AppDispatch & ThunkDispatch<State, any, AnyAction>>()

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
